<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png" alt="IsoEvolve" height="50"
                 class="mr-0 lg:mr-6">
        </div>
    </div>
</template>


<script>

export default {};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
